const DarwinTrafficLightsPlaceholder = ({
  isFullScreen,
}: {
  isFullScreen: boolean;
}) => {
  return (
    <div className="w-[90px] draggable flex justify-center">
      {isFullScreen && (
        <div className="items-center flex flex-row gap-2">
          <div
            className="border rounded-2xl w-3 h-3 hover:bg-ds-danger no-drag hover:border-0"
            onClick={() => window.dsDesktop?.app.closeApp()}
          />
          <div className="border rounded-2xl w-3 h-3" />
          <div
            className="border rounded-2xl w-3 h-3 hover:bg-ds-accent2-400 no-drag hover:border-0"
            onClick={() => window.dsDesktop?.app.toggleFullScreen()}
          />
        </div>
      )}
    </div>
  );
};

export default DarwinTrafficLightsPlaceholder;
